<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<div class="navigation">
    <div class="header">
        <a href="{{ SikluMainUrl }}" rel="noopener" target="_blank">
            <span class="logo-img"></span>
        </a>
        <div *windeHasAnyAuthority="userAuthorities.ANONYMOUS">
            <span>{{ 'global.productName' | translate }}</span>
        </div>
        @if (projectInfoService.isShow) {
            <div class="info">
                <div suiTooltip tooltipText="Project name">
                    <span class="project-name">{{ projectInfoService.projectName }}</span>
                </div>
                @if (projectInfoService.isShowLayers) {
                    <select (change)="projectInfoService.layerChanged()" [(ngModel)]="projectInfoService.activeLayer" class="layer-select">
                        @for (layer of projectInfoService.layersOptions; track $index) {
                            <option [ngValue]="layer.key">{{ layer.value }}</option>
                        }
                    </select>
                }

                <div class="details">
                <span [disabled]="tooltipsAreDisabled" position="bottom" suiTooltip tooltipText="Number of connected Locations"
                >{{ projectInfoService.numberOfConnectedTu }}
                </span>
                    <span>/</span>
                    <span [disabled]="tooltipsAreDisabled" position="bottom" suiTooltip tooltipText="Number of Locations to connect"
                    >{{ projectInfoService.nodesToConnect.get(projectInfoService.activeLayer) || 0 }}
                </span>
                </div>
            </div>
        }
    </div>
    <div class="menu">
        <div *windeHasAnyAuthority="userAuthorities.ANONYMOUS" class="login-form">
            <winde-login-modal></winde-login-modal>
        </div>
        @if (isAuthenticated()) {
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL"
                    [disableRipple]="true"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="nav-item"
                    mat-button
                    routerLink="/"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon [tooltipText]="'navbar.planner' | translate" class="nav-icon" icon="home" position="bottom" suiTooltip/>
                    <span class="nav-title">{{ 'navbar.planner' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                    [disableRipple]="true"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLink="/customers"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon
                            [tooltipText]="'navbar.companies' | translate"
                            class="nav-icon"
                            icon="briefcase"
                            position="bottom"
                            suiTooltip
                    />
                    <span class="nav-title">{{ 'navbar.companies' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                    [disableRipple]="true"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLink="/engineers"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon
                            [tooltipText]="'navbar.engineersManagement' | translate"
                            class="nav-icon"
                            icon="users"
                            position="bottom"
                            suiTooltip
                    />
                    <span class="nav-title">{{ 'navbar.engineersManagement' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.COMPANY_ADMIN"
                    [disableRipple]="true"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLink="/users"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon [tooltipText]="'navbar.users' | translate" class="nav-icon" icon="users" position="bottom" suiTooltip/>
                    <span class="nav-title">{{ 'navbar.users' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL"
                    [disableRipple]="true"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLink="/products"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon [tooltipText]="'navbar.products' | translate" class="nav-icon" icon="wifi" position="bottom" suiTooltip/>
                    <span class="nav-title">{{ 'navbar.products' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL_COMPANY"
                    [disableRipple]="true"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLink="/projects"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon [tooltipText]="'navbar.projects' | translate" class="nav-icon" icon="asterisk" position="bottom"
                                  suiTooltip/>
                    <span class="nav-title">{{ 'navbar.projects' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                    [disableRipple]="true"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLink="/project-eng"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon [tooltipText]="'navbar.projects' | translate" class="nav-icon" icon="asterisk" position="bottom"
                                  suiTooltip/>
                    <span class="nav-title">{{ 'navbar.projects' | translate }}</span>
                </button>
            </a>

            <a
                    *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                    [disableRipple]="true"
                    [matMenuTriggerFor]="reports"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLinkActive="active"
            >
                <button class="has-menu" windeTransparent>
                    <sui-svg-icon [tooltipText]="'navbar.reports' | translate" class="nav-icon" icon="file-text" position="bottom"
                                  suiTooltip/>
                    <span class="nav-title">{{ 'navbar.reports' | translate }}</span>
                </button>
            </a>

            <mat-menu #reports="matMenu" xPosition="before">
                <a
                        *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                        class="nav-item sub-menu"
                        mat-menu-item
                        routerLink="/system-reports/audits"
                        routerLinkActive="active"
                >
                    <button windeTransparent>
                        <sui-svg-icon class="nav-icon" icon="table"/>
                        <span class="nav-title">{{ 'navbar.audits' | translate }}</span>
                    </button>
                </a>
                <a
                        *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                        class="nav-item sub-menu"
                        mat-menu-item
                        routerLink="/system-reports/companies-overview"
                        routerLinkActive="active"
                >
                    <button windeTransparent>
                        <sui-svg-icon class="nav-icon" icon="list-alt"/>
                        <span class="nav-title">{{ 'navbar.companiesOverview' | translate }}</span>
                    </button>
                </a>
                <a
                        *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                        class="nav-item sub-menu"
                        mat-menu-item
                        routerLink="/system-reports/user-activity-overview"
                        routerLinkActive="active"
                >
                    <button windeTransparent>
                        <sui-svg-icon class="nav-icon" icon="history"/>
                        <span class="nav-title">{{ 'navbar.userActivityOverview' | translate }}</span>
                    </button>
                </a>
            </mat-menu>
        }
        <a
                *windeHasAnyAuthority="userAuthorities.ANY_USER"
                [disableRipple]="true"
                [matMenuTriggerFor]="help"
                [routerLinkActiveOptions]="{ exact: false }"
                class="nav-item"
                mat-button
                routerLinkActive="active"
        >
            <button class="has-menu" windeTransparent>
                <sui-svg-icon [tooltipText]="'navbar.help' | translate" class="nav-icon" icon="question" position="bottom" suiTooltip/>
                <span class="nav-title">{{ 'navbar.help' | translate }}</span>
            </button>
        </a>
        <mat-menu #help="matMenu" xPosition="before">
            <a *windeHasAnyAuthority="userAuthorities.ANY_USER" class="nav-item sub-menu" mat-menu-item routerLinkActive="active">
                <button (click)="showAbout()" windeTransparent>
                    <sui-svg-icon class="nav-icon" icon="info-circle"/>
                    <span class="nav-title">{{ 'navbar.about' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL"
                    class="nav-item sub-menu"
                    mat-menu-item
                    routerLink="/release-notes"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon class="nav-icon" icon="file-text"/>
                    <span class="nav-title">{{ 'navbar.releaseNotes' | translate }}</span>
                </button>
            </a>
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL"
                    class="nav-item sub-menu"
                    mat-menu-item
                    routerLink="/user-manual"
                    routerLinkActive="active"
            >
                <button windeTransparent>
                    <sui-svg-icon class="nav-icon" icon="book"/>
                    <span class="nav-title">{{ 'navbar.userManual' | translate }}</span>
                </button>
            </a>
            <a *windeHasAnyAuthority="userAuthorities.ALL" class="nav-item sub-menu" mat-menu-item routerLinkActive="active">
                <button (click)="reportProblem()" windeTransparent>
                    <sui-svg-icon class="nav-icon" icon="exclamation-triangle"/>
                    <span class="nav-title">{{ 'navbar.reportProblem' | translate }}</span>
                </button>
            </a>
        </mat-menu>
        @if (isAuthenticated()) {
            <a
                    *windeHasAnyAuthority="userAuthorities.ALL"
                    [disableRipple]="true"
                    [matMenuTriggerFor]="account"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="nav-item"
                    mat-button
                    routerLinkActive="active"
            >
                <button class="has-menu" windeTransparent>
                    <sui-svg-icon
                            [tooltipText]="'navbar.account' | translate"
                            class="nav-icon"
                            icon="user-single"
                            position="bottom"
                            suiTooltip
                    />
                    <span class="nav-title">{{ 'navbar.account' | translate }}</span>
                </button>
            </a>
            <mat-menu #account="matMenu" xPosition="before">
                <a
                        *windeHasAnyAuthority="userAuthorities.ALL"
                        class="nav-item sub-menu"
                        mat-menu-item
                        routerLink="/settings"
                        routerLinkActive="active"
                >
                    <button windeTransparent>
                        <sui-svg-icon class="nav-icon" icon="wrench"/>
                        <span class="nav-title">{{ 'navbar.settings' | translate }}</span>
                    </button>
                </a>
                <a
                        *windeHasAnyAuthority="userAuthorities.ALL"
                        class="nav-item sub-menu"
                        mat-menu-item
                        routerLink="/password"
                        routerLinkActive="active"
                >
                    <button windeTransparent>
                        <sui-svg-icon class="nav-icon" icon="key"/>
                        <span class="nav-title">{{ 'navbar.password' | translate }}</span>
                    </button>
                </a>
                <a *windeHasAnyAuthority="userAuthorities.ALL" class="nav-item sub-menu" mat-menu-item routerLinkActive="active">
                    <button (click)="logout()" windeTransparent>
                        <sui-svg-icon class="nav-icon" icon="sign-out"/>
                        <span class="nav-title">{{ 'navbar.logout' | translate }}</span>
                    </button>
                </a>
            </mat-menu>
            <a (click)="showNotificationsWindow(!notificationsService.showNotifications)"
               *windeHasAnyAuthority="userAuthorities.PROJECT_EDIT" [disableRipple]="true" class="nav-item"
               mat-button>
                @if (stateIndicatorIconClass) {
                    <sui-svg-icon [ngClass]="stateIndicatorIconClass" class="nav-icon notification-state" icon="refresh"/>
                }
                <button
                        class="nav-link notification_icon"
                        windeTransparent
                >
                    <sui-svg-icon [tooltipText]="'Notifications' | translate" class="nav-icon" icon="bell" position="bottom" suiTooltip/>
                </button>
            </a>
        }
    </div>
</div>

@if (notificationsService.showNotifications) {
    <div class="notifications-container">
        <winde-notifications></winde-notifications>
    </div>
}
